import styled from '@emotion/styled'

const StyledSelect = styled.select`
  color: #00f;
`;

export default StyledSelect;